<template>
  <div class="mc-dashboard row">
    <div :class="version == 2 && hasAccess(['ai-llm-integration:read']) ? 'col-md-9' : 'col-md-12'">
      <div class="row mb-3">
        <div class="col-md-12">
          <div
            :class="{
              'mc-table-filter': true,
              'd-flex': true,
              'align-items-center': true,
              'justify-content-space-between': vehicleGroupFilter.length > 0,
              'justify-content-end': vehicleGroupFilter.length <= 0,
            }"
          >
            <McAlert
              class="mc-alert-dashboard"
              v-if="vehicleGroupFilter.length > 0"
              variant="info"
              :html="
                $t('dashboard.text.vgroupFilterDesc', {
                  vgroupNames: getVehicleGroupNames,
                })
              "
              withIcon
              :withGap="false"
            />
            <div class="mc-table-view ms-2" v-if="!isLayoutEdit">
              <div class="d-flex align-items-center">
                <span id="tooltip-info">
                  <i class="mc-fa icon-outline_info"></i>
                </span>
                <multiselect
                  v-model="pembaruan"
                  :options="refreshTimeOption"
                  track-by="key"
                  label="label"
                  @input="changeRefreshTime"
                />
              </div>
              <b-tooltip target="tooltip-info" triggers="hover" placement="topleft">
                <p v-if="pembaruan.key == 0">{{ $t('dashboard.text.noUpdate') }}</p>
                <p v-else>{{ $t('dashboard.text.updated') }} {{ pembaruan.label }}</p>
              </b-tooltip>
            </div>

            <div class="mc-table-view" v-if="isHaveVehicleGroupFilterAccess">
              <multiselect
                v-model="vehicleGroupFilter"
                :options="vgroups.vgroups"
                label="name"
                track-by="id"
                :placeholder="$t('report.fields.vehicleGroup')"
                :multiple="true"
                :loading="vehicleGroupLoading"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <div class="multiselect__tags-wrap" v-if="values.length && !isOpen">
                    <b-row>
                      <b-col md="9">
                        <span class="multiselect__tag">
                          <span>{{ values[0].name }}</span>
                          <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                        </span>
                      </b-col>
                      <b-col md="1">
                        <span
                          class="badge bg-success px-1 py-1 d-inline-block"
                          v-if="values.length > 1 && !isOpen"
                          >+{{ values.length - 1 }}</span
                        >
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </multiselect>
            </div>

            <mc-date-picker
              v-if="version == 2"
              v-model="period"
              :placeholder="$t('global.action.selectDate')"
              format="DD MMM YYYY"
              value-type="YYYY-MM-DD"
              :shortcuts="makeShortcuts"
              :draft="true"
              range-separator=" - "
              range
              @input="changeDateRange"
              :disabled="isLayoutEdit"
              :confirm="true"
              :confirm-text="$t('global.action.apply')"
              ref="periodePicker"
              :lang="datePickerLang"
              :disabled-date="disabledRange"
              @pick="pickDate"
              @close="closePicker"
            >
              <template #footer>
                <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">{{
                  $t('global.action.cancel')
                }}</b-button>
              </template>
            </mc-date-picker>

            <b-button variant="outline-primary" class="ms-2" @click="refreshAll">
              <i class="mc-fa icon-fill_refresh"></i>
            </b-button>
            <b-button
              v-if="version == 2"
              variant="outline-primary"
              class="mc-ico ms-2"
              @click="openFilter"
            >
              <i class="mc-fa icon-outline_filter"></i>
            </b-button>
            <a
              class="popup-form btn btn-outline-primary"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> {{ $t('dashboard.object.widget') }}
            </a>
            <b-button
              v-if="version == 1"
              variant="outline-primary"
              class="mc-ico ms-2"
              @click="editLayout"
            >
              <i class="mc-fa icon-outline_settings"></i>
            </b-button>
            <b-button
              variant="outline-danger"
              class="mc-ico ms-2"
              v-if="isLayoutEdit"
              @click="cancelEditLayout"
            >
              <i class="icon-outline_close"></i>
              {{ $t('global.action.cancel') }}
            </b-button>
            <b-button variant="success" class="mc-ico ms-2" v-if="isLayoutEdit" @click="saveLayout">
              <i class="icon-outline_checkmark"></i>
              {{ $t('global.action.apply') }}
            </b-button>
          </div>
        </div>
      </div>
      <draggable v-model="getLayoutOrder" class="row" draggable=".mc-drag--dashboard">
        <b-col
          v-for="layout in getLayoutOrder"
          :key="layout.key"
          :sm="layout.sm"
          :md="layout.md"
          class="drag-item"
        >
          <FuelSummaryCards
            v-if="layout.key == 'fuelSummary' && version == 2"
            :isLayoutEdit="isLayoutEdit"
            ref="fuelSummaryRef"
          />
          <FuelConsumptionTrendChart
            v-if="layout.key == 'fuelConsumptionTrend' && version == 2"
            :isLayoutEdit="isLayoutEdit"
            ref="fuelConsumptionTrendRef"
          />
          <FuelAlertLog
            v-if="layout.key == 'fuelAlertLog' && version == 2"
            ref="fuelAlertLogRef"
            :isLayoutEdit="isLayoutEdit"
          />
          <FuelUsage
            v-if="layout.key == 'fuelUsage' && hasAccess(['total_fuel_consumption:read'])"
            :isLayoutEdit="isLayoutEdit"
            ref="fuelUsageRef"
          />
          <FuelStatistic
            v-if="layout.key == 'fuelStatistic' && hasAccess(['dasbor_alert_fuel:read'])"
            :isLayoutEdit="isLayoutEdit"
            ref="fuelStatisticRef"
          />
          <Top20Card
            v-if="layout.key == 'bestUsage' && hasAccess(['dasbor_top20_fuel_efficiency:read'])"
            :isLayoutEdit="isLayoutEdit"
            :fields="fieldsBestUsage"
            :cardTitle="$t('dashboard.title.top20UseFuel')"
            @filter="handleBestUsage"
            ids="bestUsage"
            ref="bestUsageRef"
          />
          <Top20Card
            v-if="layout.key == 'worstUsage' && hasAccess(['dasbor_top20_fuel_efficiency:read'])"
            :isLayoutEdit="isLayoutEdit"
            :fields="fieldsWorstUsage"
            :cardTitle="$t('dashboard.title.top20UseInefficientFuel')"
            @filter="handleWorstUsage"
            ids="worstUsage"
            ref="worstUsageRef"
          />
          <DailyFuelComparation
            v-if="
              layout.key == 'dailyComparation' && hasAccess(['dasbor_daily_fuel_comparison:read'])
            "
            :isLayoutEdit="isLayoutEdit"
            ref="dailyFuelRef"
          />
          <ChartWidget
            v-if="
              layout.key == 'monthlyComparation' &&
              hasAccess(['dasbor_monthly_fuel_comparison:read'])
            "
            :cardTitle="$t('dashboard.title.monthlyFuelComparation')"
            :isLayoutEdit="isLayoutEdit"
            ids="monthlyComparation"
            :yLabel="monthlyComparationLabel"
            hasConfig
            @filter="handleFuelMonthly"
            ref="monthlyComparationRef"
          />
          <ChartWidget
            v-if="
              layout.key == 'totalFleet' && hasAccess(['dasbor_monthly_total_not_efficiency:read'])
            "
            :cardTitle="$t('dashboard.title.inneficientFleet')"
            :isLayoutEdit="isLayoutEdit"
            ids="totalFleet"
            :yLabel="$t('global.object.totalFleet')"
            withLabel
            :ranged="false"
            @filter="handleTotalFleet"
            ref="totalFleetRef"
          />
          <MonthlyEfficiency
            v-if="
              layout.key == 'fuelEfficiency' && hasAccess(['dasbor_monthly_fuel_efficiency:read'])
            "
            :isLayoutEdit="isLayoutEdit"
            ref="fuelEfficiencyRef"
          />
          <ChartWidget
            v-if="layout.key == 'fuelLoss' && hasAccess(['dasbor_monthly_fuel_loss:read'])"
            :cardTitle="$t('dashboard.title.monthlyFuelLoss')"
            :isLayoutEdit="isLayoutEdit"
            ids="fuelLoss"
            :yLabel="$t('dashboard.chart.totalAnomaly')"
            color="#2076da"
            hasConfig
            withLabel
            @filter="handleFuelLoss"
            ref="fuelLossRef"
          />
        </b-col>
      </draggable>
    </div>
    <div
      class="col-md-3 card p-0 mc-fuel-insight-card"
      v-if="hasAccessAll(['ai-llm-integration:read']) && version == 2"
    >
      <div class="card-body">
        <FuelInsight ref="fuelInsight" />
      </div>
    </div>
    <ModalFilter ref="modal-filter" :config="filterConfig" @refresh-table="forceRerender" />
  </div>
</template>
<script>
import McAlert from '@/components/McAlert'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import {
  GET_FLEET_EFFICIENCY,
  GET_MONTHLY_FUEL_COMPARISON,
} from '@/services/api/dashboard/dashboard'
import { GET_REPORT_SUMMARY_FUEL } from '@/services/api/report/report'
import { GET_VEHICLE_GROUPS } from '@/services/api/setting/fleet/fleetGroup'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import ChartWidget from '../components/ChartWidget'
import DailyFuelComparation from '../components/DailyFuelComparation'
import FuelInsight from '../components/FuelInsight'
import FuelStatistic from '../components/FuelStatistic'
import FuelUsage from '../components/FuelUsage'
import MonthlyEfficiency from '../components/MonthlyEfficiency'
import Top20Card from '../components/Top20Card'
import FuelSummaryCards from '../components/FuelSummaryCards.vue'
import FuelConsumptionTrendChart from '../components/FuelConsumptionTrendChart.vue'
import FuelAlertLog from '../components/FuelAlertLog.vue'
import { QueryCache } from '@/mixin/query-cache'
import datePickerLang from '@/helpers/date-picker-lang'
import { dashboardFilterConfig } from '@/router/views/dashboards/contents/lib/filter-config.js'
import ModalFilter from '@/router/views/dashboards/components/ModalFilter'
import McDatePicker from '@/components/McDatePicker'

moment.locale('id')

export default {
  name: 'FuelContent',
  components: {
    Multiselect,
    draggable,
    FuelUsage,
    FuelStatistic,
    Top20Card,
    DailyFuelComparation,
    ChartWidget,
    MonthlyEfficiency,
    McAlert,
    FuelInsight,
    FuelSummaryCards,
    FuelConsumptionTrendChart,
    FuelAlertLog,
    ModalFilter,
    McDatePicker,
  },
  mixins: [Helper, MixPanel],
  apollo: {
    vgroups: {
      query: GET_VEHICLE_GROUPS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.vehicleGroupLoading = false
        }
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      config: {},
      pembaruan: {
        key: '0',
        label: this.$t('dashboard.label.disable'),
      },
      refreshInterval: '',
      refreshData: false,
      isLayoutEdit: false,
      layoutOrderV1: [
        { key: 'fuelUsage', md: 12, sm: 12, order: 1 },
        { key: 'fuelStatistic', md: 12, sm: 12, order: 2 },
        { key: 'bestUsage', md: 6, sm: 12, order: 3 },
        { key: 'worstUsage', md: 6, sm: 12, order: 4 },
        { key: 'dailyComparation', md: 12, sm: 12, order: 5 },
        { key: 'monthlyComparation', md: 6, sm: 12, order: 6 },
        { key: 'totalFleet', md: 6, sm: 12, order: 7 },
        { key: 'fuelEfficiency', md: 12, sm: 12, order: 8 },
        { key: 'fuelLoss', md: 6, sm: 12, order: 9 },
      ],
      layoutOrderV2: [
        { key: 'fuelSummary', md: 12, sm: 12, order: 1 },
        { key: 'fuelConsumptionTrend', md: 12, sm: 12, order: 2 },
        { key: 'fuelAlertLog', md: 12, sm: 12, order: 3 },
      ],
      monthlyComparationLabel: '',
      vgroups: {
        vgroups: [],
      },
      vehicleGroupFilter: [],
      vehicleGroupLoading: true,
      isFuelInsightContentFilled: false,
      filter: {
        vgroups: {
          value: [],
          detail: [],
        },
        vehicleType: {
          value: [],
          detail: [],
        },
      },
      period: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      groupBy: 'date',
      queryCache: new QueryCache(),
      key: 'dashboardFuel',
      filterValue: {},
      pastDate: moment().subtract(2, 'years'),
      futureEnd: moment(),
      currentPastDate: moment().subtract(2, 'years'),
      currentFutureEnd: moment(),
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    filterConfig() {
      return dashboardFilterConfig.find((item) => item.key == this.key)
    },
    version() {
      return this.hasAccess(['summary-fuel-dashboard-revamp:read']) ? 2 : 1
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const dateStart = new Date()
            const dateEnd = new Date()
            dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
            dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
            dateStart.setHours(0, 0, 0, 0)
            dateEnd.setHours(23, 59, 59, 999)
            return [dateStart, dateEnd]
          },
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 6)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last30Days'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 29)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.thisMonth'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * (date.getDate() - 1))
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.lastMonth'),
          onClick: () => {
            const awal = new Date()
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * awal.getDate())
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * (awal.getDate() - 1))

            const akhir = new Date()
            akhir.setTime(akhir.getTime() - 3600 * 1000 * 24 * akhir.getDate())

            return [awal, akhir]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },
    datePickerLang() {
      return datePickerLang()
    },
    getLayoutOrder() {
      if (this.version == 1) {
        return this.layoutOrderV1
      } else {
        return this.layoutOrderV2
      }
    },
    refreshTimeOption() {
      return [
        {
          key: 2,
          label: `${this.$t('dashboard.label.update')} 2 ${this.$t('global.time.minutes')}`,
        },
        {
          key: 5,
          label: `${this.$t('dashboard.label.update')} 5 ${this.$t('global.time.minutes')}`,
        },
        {
          key: 10,
          label: `${this.$t('dashboard.label.update')} 10 ${this.$t('global.time.minutes')}`,
        },
        { key: 0, label: this.$t('dashboard.label.disable') },
      ]
    },

    vgroupIdsFilter() {
      if (this.vehicleGroupFilter.length > 0) {
        return this.vehicleGroupFilter.map((item) => item.id)
      }
      return undefined
    },

    fieldsBestUsage() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('report.fields.licensePlate'),
        },
        {
          key: 'totalFuel',
          label: this.$t('report.fields.fuelUsage'),
        },
      ]
    },
    fieldsWorstUsage() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('report.fields.licensePlate'),
        },
        {
          key: 'actualEfficiency',
          label: this.$t('report.fields.actualEfficiency'),
        },
        {
          key: 'fuelEfficiencyDifference',
          label: this.$t('dashboard.text.difference'),
        },
      ]
    },
    isHaveVehicleGroupFilterAccess() {
      return this.hasAccess(['a1h-dashboard-vgroupfilter:read']) && this.version == 1
    },

    getVehicleGroupNames() {
      let vgroupNames = []
      if (this.vehicleGroupFilter.length > 0) {
        vgroupNames = this.vehicleGroupFilter.map((item) => item.name)
      }

      if (vgroupNames.length > 2) {
        return (
          vgroupNames.slice(0, 2).join(', ') +
          ` ${this.$t('global.and')} ${vgroupNames.length - 2} ${this.$t('global.others')}`
        )
      } else if (vgroupNames.length > 0) {
        return vgroupNames.join(', ')
      }

      return null
    },
  },
  mounted() {
    this.config = JSON.parse(localStorage.getItem('dashboard-fuel-config'))
    if (!this.config) {
      localStorage.setItem(
        'dashboard-fuel-config',
        JSON.stringify({
          refreshTime: {
            key: 0,
            label: this.$t('dashboard.label.disable'),
          },
        })
      )
      this.config = JSON.parse(localStorage.getItem('dashboard-fuel-config'))
    }
    this.loadFuelDashboardFilterLocalStorage()
    this.pembaruan = this.config.refreshTime
    this.refreshAll()
    let layoutOrderCached = JSON.parse(localStorage.getItem('dashboard-fuel-layout'))
    if (Array.isArray(layoutOrderCached)) {
      this.layoutOrderV1 = layoutOrderCached
    } else if (layoutOrderCached?.version == 1) {
      this.layoutOrderV1 = layoutOrderCached.layoutOrder
    } else if (layoutOrderCached?.version == 2) {
      this.layoutOrderV2 = layoutOrderCached.layoutOrder
    }
  },
  watch: {
    vgroupIdsFilter() {
      this.refreshAll()
    },
  },
  methods: {
    closePicker() {
      this.currentPastDate = moment().subtract(2, 'years')
      this.currentFutureEnd = moment()
    },
    pickDate(date) {
      let maxDate = 30

      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000).toString() == new Date().toString()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    disabledRange: function (date) {
      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd
      )
    },
    loadFuelDashboardFilterLocalStorage() {
      const filter = JSON.parse(localStorage.getItem('dashboard-fuel-filter'))
      if (filter) {
        this.filterValue = filter.filterValue
        this.filter.vgroups.value = this.filterValue?.vehicleGroupId ?? []
        this.filter.vehicleType.value = this.filterValue?.vehicleTypeId ?? []
        this.filter.vgroups.detail = this.filterValue?.fullObjects?.vehicleGroupId ?? []
        this.filter.vehicleType.detail = this.filterValue?.fullObjects?.vehicleTypeId ?? []
        this.period = filter.period
      }
    },
    setFuelDashboardFilterLocalStorage() {
      localStorage.setItem(
        'dashboard-fuel-filter',
        JSON.stringify({
          filterValue: this.filterValue,
          period: this.period,
        })
      )
    },
    closeCalendar() {
      this.$refs.periodePicker.cancel()
    },
    forceRerender() {
      this.filterValue = this.$store.state.dashboard.filterValue
      this.filter.vgroups.value = this.filterValue?.vehicleGroupId ?? []
      this.filter.vehicleType.value = this.filterValue?.vehicleTypeId ?? []
      this.filter.vgroups.detail = this.filterValue?.fullObjects?.vehicleGroupId ?? []
      this.filter.vehicleType.detail = this.filterValue?.fullObjects?.vehicleTypeId ?? []
      this.setFuelDashboardFilterLocalStorage()
      this.refreshAll()
    },
    openFilter() {
      this.$refs['modal-filter'].SetFormValues(this.filterValue)
      this.$bvModal.show(this.filterConfig.modal)
    },
    changeDateRange() {
      this.setFuelDashboardFilterLocalStorage()
      this.refreshAll()
    },
    changeRefreshTime(data) {
      let currentDate = moment().format('YYYY-MM-DD')
      if (
        this.$refs.fuelUsageRef &&
        data.key != 0 &&
        currentDate >= this.$refs.fuelUsageRef[0].periode[0] &&
        currentDate <= this.$refs.fuelUsageRef[0].periode[1]
      ) {
        this.refreshAll()
      }
      localStorage.setItem('dashboard-fuel-config', JSON.stringify({ refreshTime: data }))
    },
    async initFuelDashboardData() {
      if (this.version == 2) {
        const filter = {
          vgroupId: this.filter.vgroups.value,
          vehicleTypeId: this.filter.vehicleType.value,
          startDate: this.period[0],
          endDate: this.period[1],
        }
        await this.$refs.fuelSummaryRef[0].loadFilter(filter)
        await this.$refs.fuelConsumptionTrendRef[0].loadFilter(filter)
        await this.$refs.fuelAlertLogRef[0].loadData(filter)
        if (this.hasAccess(['ai-llm-integration:read'])) {
          await this.$refs.fuelInsight.initData({
            vgroupId: this.filter.vgroups.value,
            vehicleTypeId: this.filter.vehicleType.value,
            startDate: this.period[0],
            endDate: this.period[1],
          })
        }
      }
    },
    async generateSumFuel() {
      if (this.hasAccess(['total_fuel_consumption:read']) && this.version == 1) {
        await this.$refs.fuelUsageRef[0].generateSumFuel(this.vgroupIdsFilter)
      }
    },
    async initRefuelStatistics() {
      if (this.hasAccess(['dasbor_alert_fuel:read']) && this.version == 1) {
        await this.$refs.fuelStatisticRef[0].initData('refuel', this.vgroupIdsFilter)
      }
    },
    async initFuelLossStatistics() {
      if (this.hasAccess(['dasbor_alert_fuel:read']) && this.version == 1) {
        await this.$refs.fuelStatisticRef[0].initData('fuelLoss', this.vgroupIdsFilter)
      }
    },
    async initFoulStatistics() {
      if (this.hasAccess(['dasbor_alert_fuel:read']) && this.version == 1) {
        await this.$refs.fuelStatisticRef[0].initData('foul', this.vgroupIdsFilter)
      }
    },
    async handleTopBestUsage() {
      if (this.hasAccess(['dasbor_top20_fuel_efficiency:read']) && this.version == 1) {
        await this.handleBestUsage()
      }
    },
    async handleTopWorstUsage() {
      if (this.hasAccess(['dasbor_top20_fuel_efficiency:read']) && this.version == 1) {
        await this.handleWorstUsage()
      }
    },
    async generateDailyFuelComparison() {
      if (this.hasAccess(['dasbor_daily_fuel_comparison:read']) && this.version == 1) {
        await this.$refs.dailyFuelRef[0].generateChart(this.vgroupIdsFilter)
        await this.$refs.dailyFuelRef[0].loadVehicleTypes(this.vgroupIdsFilter)
      }
    },
    async handleMonthlyFuelComparison() {
      if (this.hasAccess(['dasbor_monthly_fuel_comparison:read']) && this.version == 1) {
        await this.handleFuelMonthly()
      }
    },
    async handleTotalFleetComparison() {
      if (this.hasAccess(['dasbor_monthly_total_not_efficiency:read']) && this.version == 1) {
        await this.handleTotalFleet()
      }
    },
    async generateMonthlyFuelEfficency() {
      if (this.hasAccess(['dasbor_monthly_fuel_efficiency:read']) && this.version == 1) {
        await this.$refs.fuelEfficiencyRef[0].generateChart(this.vgroupIdsFilter)
      }
    },
    async handleMonthlyFuelLoss() {
      if (this.hasAccess(['dasbor_monthly_fuel_loss:read']) && this.version == 1) {
        await this.handleFuelLoss()
      }
    },
    startAutoRefresh() {
      const refreshDataIfWithinPeriod = (ref, period, callback) => {
        const currentDate = moment().format('YYYY-MM-DD')
        if (currentDate <= period[1]) {
          callback.call(this)
        }
      }

      if (this.pembaruan.key !== 0) {
        this.refreshInterval = setInterval(() => {
          if (this.$route.path !== '/') {
            clearInterval(this.refreshInterval)
            return
          }
          if (this.$refs.fuelUsageRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelUsageRef[0],
              this.$refs.fuelUsageRef[0].periode,
              this.generateSumFuel
            )
          if (this.$refs.fuelStatisticRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelStatisticRef[0],
              this.$refs.fuelStatisticRef[0].refuelPeriod,
              this.initRefuelStatistics
            )
          if (this.$refs.fuelStatisticRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelStatisticRef[0],
              this.$refs.fuelStatisticRef[0].fuelLossPeriod,
              this.initFuelLossStatistics
            )
          if (this.$refs.fuelStatisticRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelStatisticRef[0],
              this.$refs.fuelStatisticRef[0].foulPeriod,
              this.initFoulStatistics
            )
          if (this.$refs.bestUsageRef)
            refreshDataIfWithinPeriod(
              this.$refs.bestUsageRef[0],
              this.$refs.bestUsageRef[0].period,
              this.handleTopBestUsage
            )
          if (this.$refs.worstUsageRef)
            refreshDataIfWithinPeriod(
              this.$refs.worstUsageRef[0],
              this.$refs.worstUsageRef[0].period,
              this.handleTopWorstUsage
            )
          if (this.$refs.dailyFuelRef)
            refreshDataIfWithinPeriod(
              this.$refs.dailyFuelRef[0],
              this.$refs.dailyFuelRef[0].period,
              this.generateDailyFuelComparison
            )
          if (this.$refs.fuelSummaryRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelSummaryRef[0],
              this.period,
              this.initFuelDashboardData
            )
          if (this.$refs.fuelConsumptionTrendRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelConsumptionTrendRef[0],
              this.period,
              this.initFuelDashboardData
            )
          if (this.$refs.fuelAlertLogRef)
            refreshDataIfWithinPeriod(
              this.$refs.fuelAlertLogRef[0],
              this.period,
              this.initFuelDashboardData
            )
          if (
            this.$refs.monthlyComparationRef &&
            moment().format('YYYY-MM') <=
              moment(this.$refs.monthlyComparationRef[0].period[1]).format('YYYY-MM')
          ) {
            this.handleMonthlyFuelComparison()
          }
          if (
            this.$refs.fuelLossRef &&
            moment().format('YYYY-MM') <=
              moment(this.$refs.fuelLossRef[0].period[1]).format('YYYY-MM')
          ) {
            this.handleMonthlyFuelLoss()
          }
        }, 60000 * Number(this.pembaruan.key))
      }
    },
    refreshAll() {
      this.generateSumFuel()
      this.initRefuelStatistics()
      this.initFuelLossStatistics()
      this.initFoulStatistics()
      this.handleTopBestUsage()
      this.handleTopWorstUsage()
      this.generateDailyFuelComparison()
      this.handleMonthlyFuelComparison()
      this.handleTotalFleetComparison()
      this.generateMonthlyFuelEfficency()
      this.handleMonthlyFuelLoss()
      this.initFuelDashboardData()
      this.startAutoRefresh()
    },
    editLayout() {
      this.isLayoutEdit = true
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.add('mc-drag--dashboard')
      })
    },
    saveLayout() {
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      let newOrder = []
      const layoutOrder = this.getLayoutOrder
      layoutOrder.forEach(function (item, index) {
        newOrder.push({
          ...item,
          order: index + 1,
        })
      })

      const layoutCached = {
        version: this.version,
        layoutOrder: newOrder,
      }
      localStorage.setItem('dashboard-fuel-layout', JSON.stringify(layoutCached))
      this.isLayoutEdit = false
      this.$forceUpdate()
    },
    cancelEditLayout() {
      if (this.version == 1) {
        this.layoutOrderV1 = this.layoutOrderV1.sort(function (a, b) {
          if (a.order < b.order) return -1
          if (a.order > b.order) return 1
          return 0
        })
      } else {
        this.layoutOrderV2 = this.layoutOrderV2.sort(function (a, b) {
          if (a.order < b.order) return -1
          if (a.order > b.order) return 1
          return 0
        })
      }

      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      this.isLayoutEdit = false
    },
    async handleBestUsage(data = null) {
      let filters = {}
      let config = JSON.parse(localStorage.getItem('bestUsage-config'))
      if (data) {
        filters = { ...data }
      } else {
        if (!config) {
          await this.$refs.bestUsageRef[0].initLocalStorage(
            'bestUsage-config',
            this.vgroupIdsFilter
          )
          config = JSON.parse(localStorage.getItem('bestUsage-config'))
        }
        await this.$refs.bestUsageRef[0].loadLocalStorage(config, this.vgroupIdsFilter)
        filters = { ...config }
      }
      const res = await this.$apollo.query({
        query: GET_REPORT_SUMMARY_FUEL,
        variables: {
          filter: {
            startDate: filters.startDate,
            endDate: filters.endDate,
            vehicleTypeId: filters.vehicleTypeId.filter((item) => item != null),
            column: [
              'license_plate',
              'vehicle_type',
              'count_refueling',
              'count_fuel_loss',
              'total_fuel',
              'total_distance',
              'total_hours',
              'idle_duration',
              'actual_efficiency',
              'standard_efficiency',
              'standard_fuel',
              'standard_price',
              'actual_price',
              'actual_total_fuel',
              'price',
            ],
            orderBy: JSON.stringify({ totalFuel: 'desc' }),
            pagination: {
              page: 1,
              show: 20,
            },
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })
      const summaryFuel = res.data.summaryFuel.summaryFuel.data.filter((item) => {
        return item.totalFuel >= 0
      })
      this.$refs.bestUsageRef[0].isLoading = true
      this.$refs.bestUsageRef[0].chartData.datasets = [
        {
          label: this.$t('dashboard.chart.fuelUse'),
          data: summaryFuel.map((item) => item.totalFuel),
          borderColor: '#0d4491',
          backgroundColor: '#0d4491',
          barThickness: 16,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        },
      ]
      this.$refs.bestUsageRef[0].initData(summaryFuel)
    },
    async handleWorstUsage(data = null) {
      let filters = {}
      let config = JSON.parse(localStorage.getItem('worstUsage-config'))
      if (data) {
        filters = { ...data }
      } else {
        if (!config) {
          await this.$refs.worstUsageRef[0].initLocalStorage(
            'worstUsage-config',
            this.vgroupIdsFilter
          )
          config = JSON.parse(localStorage.getItem('worstUsage-config'))
        }
        await this.$refs.worstUsageRef[0].loadLocalStorage(config, this.vgroupIdsFilter)
        filters = { ...config }
      }
      const res = await this.$apollo.query({
        query: GET_REPORT_SUMMARY_FUEL,
        variables: {
          filter: {
            startDate: filters.startDate,
            endDate: filters.endDate,
            vehicleTypeId: filters.vehicleTypeId.filter((item) => item != null),
            column: [
              'license_plate',
              'vehicle_type',
              'count_refueling',
              'count_fuel_loss',
              'total_fuel',
              'total_distance',
              'total_hours',
              'idle_duration',
              'actual_efficiency',
              'standard_efficiency',
              'standard_fuel',
              'standard_price',
              'actual_price',
              'actual_total_fuel',
              'fuel_difference',
              'fuel_difference_price',
              'fuel_efficiency_difference',
            ],
            orderBy: JSON.stringify({ fuelEfficiencyDifference: 'desc' }),
            pagination: {
              page: 1,
              show: 20,
            },
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })

      const summaryFuel = res.data.summaryFuel.summaryFuel.data.filter((item) => {
        return item.fuelEfficiencyDifference > 0
      })
      summaryFuel.forEach((item) => {
        if (item.actualEfficiency !== null) {
          item.actualEfficiency = this.minimizeFloat(item.actualEfficiency)
        }
      })
      this.$refs.worstUsageRef[0].isLoading = true
      this.$refs.worstUsageRef[0].chartData.datasets = [
        {
          label: this.$t('dashboard.chart.actualEfficiency'),
          data: summaryFuel.map((item) => item.actualEfficiency),
          borderColor: '#f41d00',
          backgroundColor: '#f41d00',
          barThickness: 16,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        },
      ]
      this.$refs.worstUsageRef[0].initData(summaryFuel)
    },
    async handleFuelMonthly(data = null) {
      let filters = {}
      let config = JSON.parse(localStorage.getItem('monthlyComparation-config'))
      if (data) {
        filters = {
          startDate: data.startDate,
          endDate: data.endDate,
          vehicleTypeId: data.vehicleTypeId,
        }
        this.monthlyComparationLabel = data.yLabel.label
      } else {
        if (!config) {
          await this.$refs.monthlyComparationRef[0].initLocalStorage(
            'monthlyComparation-config',
            this.vgroupIdsFilter
          )
          config = JSON.parse(localStorage.getItem('monthlyComparation-config'))
        }
        await this.$refs.monthlyComparationRef[0].loadLocalStorage(config, this.vgroupIdsFilter)
        filters = {
          startDate: config.startDate,
          endDate: config.endDate,
          vehicleTypeId: config.vehicleTypeId,
        }
        this.monthlyComparationLabel = config.yLabel.label
      }
      this.$refs.monthlyComparationRef[0].isLoading = true
      const res = await this.$apollo.query({
        query: GET_MONTHLY_FUEL_COMPARISON,
        variables: {
          filter: {
            ...filters,
            column: [
              'total_distance',
              'actual_efficiency',
              'standard_price',
              'standard_fuel',
              'actual_price',
              'actual_total_fuel',
            ],
            orderBy: JSON.stringify({ year: 'asc' }),
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })

      const summaryFuelMonthly = res.data.summaryFuelMonthly.summaryFuelMonthly

      this.$refs.monthlyComparationRef[0].chartData.labels = summaryFuelMonthly.map((item) =>
        this.momentMMM(item.month)
      )
      this.$refs.monthlyComparationRef[0].chartData.datasets = [
        {
          type: 'line',
          label: this.$t('dashboard.text.standard'),
          data:
            this.monthlyComparationLabel === this.$t('dashboard.text.litre')
              ? summaryFuelMonthly.map((item) => this.minimizeFloat(item.sumStandardFuel))
              : summaryFuelMonthly.map((item) => this.minimizeFloat(item.sumStandardPrice)),
          borderColor: '#f1734f',
          fill: false,
          pointRadius: 2,
          lineTension: 0,
          borderWidth: 4,
        },
        {
          type: 'bar',
          label: this.$t('dashboard.text.actual'),
          data:
            this.monthlyComparationLabel === this.$t('dashboard.text.litre')
              ? summaryFuelMonthly.map((item) => this.minimizeFloat(item.sumActualTotalFuel))
              : summaryFuelMonthly.map((item) => this.minimizeFloat(item.sumActualPrice)),
          borderColor: '#0d4491',
          backgroundColor: '#0d4491',
          barPercentage: 0.4,
        },
      ]
      this.$refs.monthlyComparationRef[0].initData()
    },
    async handleTotalFleet(data = null) {
      let filters = {}
      let config = JSON.parse(localStorage.getItem('totalFleet-config'))
      if (data) {
        filters = { ...data }
      } else {
        if (!config) {
          await this.$refs.totalFleetRef[0].initLocalStorage(
            'totalFleet-config',
            this.vgroupIdsFilter
          )
          config = JSON.parse(localStorage.getItem('totalFleet-config'))
        }
        await this.$refs.totalFleetRef[0].loadLocalStorage(config, this.vgroupIdsFilter)
        filters = { ...config }
      }

      this.$refs.totalFleetRef[0].isLoading = true
      const res = await this.$apollo.query({
        query: GET_FLEET_EFFICIENCY,
        variables: {
          filter: {
            date: filters.endDate,
            vehicleTypeId: filters.vehicleTypeId,
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })

      const totalFleet =
        res.data.vehicleTypeEfficiencyComparison.vehicleTypeEfficiencyComparison.data
      this.$refs.totalFleetRef[0].chartData.labels = totalFleet.map(
        (item) => `${item.vehicleType.model}/${item.vehicleType.type}`
      )
      this.$refs.totalFleetRef[0].chartData.datasets = [
        {
          type: 'bar',
          label: this.$t('global.object.totalFleet'),
          data: totalFleet.map((item) => item.totalVehicle),
          borderColor: '#0d4491',
          backgroundColor: '#0d4491',
          barPercentage: 1.0,
          categoryPercentage: 0.2,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        },
        {
          type: 'bar',
          label: this.$t('dashboard.text.inneficientFleet'),
          data: totalFleet.map((item) => item.totalInefficientVehicle),
          borderColor: '#f41d00',
          backgroundColor: '#f41d00',
          barPercentage: 1.0,
          categoryPercentage: 0.2,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        },
      ]
      this.$refs.totalFleetRef[0].initData()
    },
    async handleFuelLoss(data = null) {
      let filters = {}
      let config = JSON.parse(localStorage.getItem('fuelLoss-config'))
      if (data) {
        filters = { ...data }
      } else {
        if (!config) {
          await this.$refs.fuelLossRef[0].initLocalStorage('fuelLoss-config', this.vgroupIdsFilter)
          config = JSON.parse(localStorage.getItem('fuelLoss-config'))
        }
        await this.$refs.fuelLossRef[0].loadLocalStorage(config, this.vgroupIdsFilter)
        filters = { ...config }
      }

      this.$refs.fuelLossRef[0].isLoading = true
      const res = await this.$apollo.query({
        query: GET_MONTHLY_FUEL_COMPARISON,
        variables: {
          filter: {
            ...filters,
            column: [
              'total_distance',
              'actual_efficiency',
              'standard_price',
              'standard_fuel',
              'actual_price',
              'actual_total_fuel',
              'count_refueling',
              'count_fuel_loss',
            ],
            orderBy: JSON.stringify({ year: 'asc' }),
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        },
        fetchPolicy: 'no-cache',
      })

      const fuelLoss = res.data.summaryFuelMonthly.summaryFuelMonthly
      this.$refs.fuelLossRef[0].chartData.labels = fuelLoss.map((item) =>
        this.momentMMM(item.month)
      )
      this.$refs.fuelLossRef[0].chartData.datasets = [
        {
          type: 'bar',
          label: this.$t('dashboard.title.fuelLossAnomaly'),
          data: fuelLoss.map((item) => item.sumCountFuelLoss),
          borderColor: '#2076da',
          borderSkipped: 'right',
          backgroundColor: '#2076da',
          barPercentage: 0.4,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        },
      ]
      this.$refs.fuelLossRef[0].initData()
    },
  },
}
</script>

<style scoped>
.mc-fuel-insight-card {
  display: block;
  overflow: hidden;
  position: relative;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.3);
  margin-bottom: 0px !important;
}

.mc-fuel-insight-card::before {
  background-image: url('~@/assets/images/dashboard/body-top-right.png'),
    url('~@/assets/images/dashboard/body-top-left.png'),
    url('~@/assets/images/dashboard/body-bottom.png');
  background-position: right top, left top, 58% bottom;
  background-repeat: no-repeat;
  background-size: 94px 76px, 121px 78px, 410px 278px;
  content: '';
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 0;
}

.mc-fuel-insight-card > * {
  position: relative;
  z-index: 1;
}

.mc-fuel-insight-filter {
  border: 1px solid #dfe3eb;
  border-radius: 4px;
  color: #344054;
  font-size: 14px;
  line-height: 20px;
  margin-top: 16px;
  padding: 8px 16px;
}

.mc-fuel-insight-filter__item {
  align-items: center;
  display: flex;
  gap: 8px;
  min-height: 22px;
}

.mc-fuel-insight-filter__item i {
  color: #344054;
  font-size: 16px;
}

.mc-fuel-insight-filter__divider {
  border-top: 1px solid #e5e7eb;
  margin: 8px 0;
}

.card-body {
  padding: 16px !important;
}
</style>
